module.exports = __webpack_public_path__ + "media/images/countryrect/cd-a0b97019f9fd60cf2c1a924ca2090ec8.svg";